import { createSearchParams } from 'react-router-dom';
import { axiosInstance } from '../base.api';
import { paths } from '../paths';
import { GetFloorsResponse } from '../type/floor.type';

export const getFloors = (posId: number): Promise<GetFloorsResponse> => {
  const requestUrl = `${paths.floors()}?${createSearchParams({ pos_id: posId.toString() })}`;
  return axiosInstance.get(requestUrl).then(item => item.data.data);
};
